// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".skip-to-content{position:absolute;left:50%;transform:translateY(-100%);background:var(--background-2);padding:16px;color:var(--body)}.skip-to-content:focus{transform:translateY(0)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
